import { render, staticRenderFns } from "./JobApproval.vue?vue&type=template&id=4075f3b2&scoped=true"
import script from "./JobApproval.vue?vue&type=script&lang=js"
export * from "./JobApproval.vue?vue&type=script&lang=js"
import style0 from "./JobApproval.vue?vue&type=style&index=0&id=4075f3b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4075f3b2",
  null
  
)

export default component.exports